var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal" }, [
    _c("div", { staticClass: "overlay" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal-content well clearfix relative" },
      [
        _c("preloader", { attrs: { display: _vm.loading } }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "modal-header" },
          [
            _vm._t("modal-header"),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "close gray-100",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.close()
                  }
                }
              },
              [_vm._v("×")]
            )
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "modal-body mt-3 prelative" },
          [_vm._t("modal-body")],
          2
        ),
        _vm._v(" "),
        _vm.hasFooter
          ? _c(
              "div",
              { staticClass: "modal-footer" },
              [_vm._t("modal-footer")],
              2
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }